import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGls = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#1C146B"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(7 7) scale(0.100626) translate(-245.560 -2.560)",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-341.95657,-178.23685)",
			id: "layer1",
			children: /* @__PURE__ */ _jsx("g", {
				id: "g4732",
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "matrix(2.4647772,0,0,2.4647772,-529.93015,-563.97862)",
					id: "g4574",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M 492.99233,347.07166 L 497.96713,321.58521 L 489.32998,321.58521 L 482.74275,355.60881 L 498.50461,355.60881 L 500.12954,347.07166 L 492.99233,347.07166 z ",
							id: "path4402",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M 518.49129,329.1474 C 519.89123,329.1474 521.94114,329.45988 523.1286,329.89737 L 524.64103,322.01019 C 522.80361,321.7977 520.86619,321.58521 518.70378,321.58521 C 509.30416,321.58521 504.87934,327.19748 504.87934,333.45972 C 504.87934,341.67188 513.304,341.55939 513.304,345.12174 C 513.304,346.85917 512.00405,347.82163 509.41666,347.82163 C 507.46674,347.82163 504.99184,347.39665 503.4794,346.74667 L 501.85447,355.17133 C 503.5794,355.60881 506.0668,355.8213 508.55419,355.8213 C 516.97885,355.8213 522.80361,350.19653 522.80361,343.39681 C 522.80361,335.40964 514.37895,335.29714 514.37895,331.73479 C 514.37895,330.22235 515.46641,329.1474 518.49129,329.1474",
							id: "path4404",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M 475.93053,321.58521 C 462.96856,321.58521 454.65391,331.29731 454.65391,343.18432 C 454.65391,350.52152 458.5425,355.70881 468.48084,355.70881 C 472.36818,355.70881 476.46801,354.95884 479.81787,353.5464 L 482.95524,337.13457 L 474.3056,337.13457 L 472.36818,347.17166 C 471.60571,347.39665 470.74325,347.39665 469.99328,347.39665 C 465.66845,347.39665 464.15602,345.02175 464.15602,341.78438 C 464.15602,335.94712 467.71837,329.78487 475.18056,329.78487 C 477.23048,329.78487 479.49289,330.22235 481.5428,330.75983 C 481.76779,330.87233 481.98028,330.97232 482.19278,330.97232 C 482.84275,331.29731 483.49272,331.5223 483.9302,331.73479 L 485.75513,322.87265 C 482.74275,322.12269 479.1679,321.58521 475.93053,321.58521",
							id: "path4406",
							fill: "#fff"
						})
					]
				})
			})
		})
	})]
});
export default SvgGls;
